import React, { useContext, useEffect, useState } from "react";
import { Card, Grid, IconButton, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { MoreVert } from "@material-ui/icons";
import clsx from "clsx";

import ScalingContext from "../../../../../context/scaling/ScalingContext";
import ParameterContext from "../../../../../context/parameters/ParameterContext";

import CardDetails from "./CardDetails";
import CardEdit from "./CardEdit";

export default function CampaignList() {
  const useStyles = makeStyles((theme) => ({
    card: {
      marginBottom: 18,
    },
    cardTesting: {
      border: `1px solid ${theme.palette.text.disabled}`,
      backgroundImage:
        "linear-gradient(to bottom right, rgba(255, 0, 0, 0.1), 20%, rgba(255, 0, 0, 0.2))",
    },
    cardOptimizing: {
      border: `1px solid ${theme.palette.text.disabled}`,
      backgroundImage:
        "linear-gradient(to bottom right, rgba(255, 165, 0, 0.1), 20%, rgba(255, 165, 0, 0.2))",
    },
    cardScaling: {
      border: `1px solid ${theme.palette.text.disabled}`,
      backgroundImage:
        "linear-gradient(to bottom right, rgba(0, 128, 0, 0.1), 20%, rgba(0, 128, 0, 0.2))",
    },
  }));
  const classes = useStyles();

  const {
    campaigns,
    campaigns_searched,
    editCampaign,
    index_selected,
    setScalingStatus,
  } = useContext(ScalingContext);
  const { checkout_languages } = useContext(ParameterContext);

  const [data, setData] = useState(null); // loaded data
  const [languages, setLanguages] = useState(null); // language object

  const handleEdit = (index, campaign) => {
    // Function: Set Selected Index, Campaign
    editCampaign(index, campaign);
  };

  const cancelEdit = () => {
    // Function: Reset Selected Index, Campaign, Scaling Status
    editCampaign(null, null);
    setScalingStatus(null);
  };

  useEffect(() => {
    // Function: Set Campaigns for Listing
    if (campaigns_searched) {
      if (JSON.stringify(data) !== JSON.stringify(campaigns_searched)) {
        setData(campaigns_searched);
      }
    } else if (campaigns) {
      if (JSON.stringify(data) !== JSON.stringify(campaigns)) {
        setData(campaigns);
      }
    }
  }, [campaigns, campaigns_searched]);

  useEffect(() => {
    // Function: Set Languages into New Object - { ...[code]: name }
    if (checkout_languages) {
      const lang_obj = checkout_languages.reduce(
        (prev, next) => ({ ...prev, [next.code]: next.name }),
        {}
      );

      setLanguages(lang_obj);
    }
  }, [checkout_languages]);

  return (
    <>
      <Grid item xs={12}>
        {" "}
        {!data || !languages ? (
          <Skeleton
            variant="rect"
            width="100%"
            height="110px"
            className={classes.card}
          />
        ) : (
          data.map((campaign, index) => {
            // Get Language Name
            const language_name = languages[campaign.language];

            return (
              <Card
                key={index}
                className={clsx(classes.card, {
                  [classes.cardTesting]: campaign.scaling_status === "TESTING",
                  [classes.cardOptimizing]:
                    campaign.scaling_status === "OPTIMIZING",
                  [classes.cardScaling]: campaign.scaling_status === "SCALING",
                })}
              >
                {index_selected === index ? (
                  <>
                    <CardDetails
                      tableWidth="100%"
                      campaign={campaign}
                      language_name={language_name}
                    />{" "}
                    <CardEdit cancelEdit={cancelEdit} />{" "}
                  </>
                ) : (
                  <Grid item container direction="column">
                    <Grid
                      item
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <CardDetails
                        tableWidth="95%"
                        campaign={campaign}
                        language_name={language_name}
                      />
                      <Grid
                        item
                        style={{
                          width: "5%",
                          textAlign: "center",
                        }}
                      >
                        <IconButton onClick={() => handleEdit(index, campaign)}>
                          <MoreVert />
                        </IconButton>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>
                )}{" "}
              </Card>
            );
          })
        )}{" "}
      </Grid>{" "}
    </>
  );
}
